import { render, staticRenderFns } from "./contentCourseLiveAddUrl.vue?vue&type=template&id=1281cc70&"
import script from "./contentCourseLiveAddUrl.vue?vue&type=script&lang=js&"
export * from "./contentCourseLiveAddUrl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports